import { useState, useEffect } from 'react';

const DEFAULT_BREAKPOINTS = [576, 701, 992, 1024]

const useResponsiveJSX = (breakpoints) => {

    const [ index, setIndex ] = useState(0);

    let set_breakpoints = breakpoints ? breakpoints : DEFAULT_BREAKPOINTS;

    useEffect(() => {
      function updateIndex(){
        const width = window.innerWidth;
        const newIndex = set_breakpoints.findIndex(bp => width <= bp);
        setIndex( newIndex === -1 ? set_breakpoints.length : newIndex );
      }

      updateIndex();
      window.addEventListener("resize", updateIndex)
    
      return () => window.removeEventListener("resize", updateIndex)
    }, [breakpoints])
    

  return index
}

export default useResponsiveJSX